module.exports = __webpack_public_path__ + "img/pricing_team.c0c14ee9.svg";